import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { InventarioFisicoController } from './inventario-fisico.controller';
import { InventarioFisicoService } from './inventario-fisico.service';

@Module({
  imports: [PrismaModule],
  controllers: [InventarioFisicoController],
  providers: [InventarioFisicoService],
  exports: [InventarioFisicoService],
})
export class InventarioFisicoModule {}
